export default __webpack_public_path__ + "static/media/line6.13caac69.svg";